import {createWebHashHistory, createRouter} from "vue-router";
import Login from "@/components/Login.vue";
import ResetPasswordPage from "@/components/ResetPasswordPage.vue";
import Dashboard from "@/components/Dashboard.vue";
import HospitalsAdd from "@/components/cbhi-hospital/HospitalsAdd.vue";
import Hospitals from "@/components/cbhi-hospital/Hospitals.vue";
import MembersAdd from "@/components/cbhi-member-management/MembersAdd.vue";
import MemberBulkUpload from "@/components/cbhi-member-management/bulk-upload/MemberBulkUpload.vue";
import MembersAll from "@/components/cbhi-member-management/MembersAll.vue";
import MembersFlagged from "@/components/cbhi-member-management/MembersFlagged.vue";
import PremiumRecords from "@/components/cbhi-member-management/premiums/PremiumRecords.vue";
import PremiumReconciliation from "@/components/cbhi-member-management/premiums/PremiumReconciliation.vue";
import PremiumCollectionsReports from "@/components/cbhi-member-management/premiums/PremiumCollectionsReports.vue";
import CashCollectionDashboard from "@/components/cbhi-finance/CashCollectionDashboard.vue";

import Designations from "@/components/cbhi-org-structuture/Designations.vue";
import Departments from "@/components/cbhi-org-structuture/Departments.vue";
import SystemManagement from "@/components/cbhi-org-structuture/SystemManagement.vue";
import AffiliatedInstitution from "@/components/cbhi-org-structuture/AffiliatedInstitution.vue";
import EmploymentTypes from "@/components/cbhi-org-structuture/EmploymentTypes.vue";
import UserRegistration from "@/components/cbhi-users/UserRegistration.vue";
import UserList from "@/components/cbhi-users/UserList.vue";
import UsersDeactivated from "@/components/cbhi-users/UsersDeactivated.vue";
import UseLogs from "@/components/cbhi-users/UseLogs.vue";
import UserProfile from "@/components/cbhi-users/UserProfile.vue";
import UsersRoles from "@/components/cbhi-users/UsersRoles.vue";
import HospitalsEdit from "@/components/cbhi-hospital/HospitalsEdit.vue";
import MemberDetails from "@/components/cbhi-member-management/MemberDetails.vue";
import MembersEdit from "@/components/cbhi-member-management/MembersEdit.vue";
import ReceivePremium from "@/components/cbhi-member-management/premiums/ReceivePremium.vue";


import ClaimsManagement from "@/components/cbhi-claims-management/ClaimsManagement.vue";
import SettlementManagement from "@/components/cbhi-settlement/SettlementManagement.vue";


import HEWDashboard from "@/components/hew/HEWDashboard.vue";
import HouseholdManagement from "@/components/hew/HouseholdManagement.vue";
import HouseholdDetails from "@/components/hew/HouseholdDetails.vue";
import MemberProfile from "@/components/hew/MemberProfile.vue";
import VisitDetails from "@/components/hew/VisitDetails.vue";
import HealthEducation from "@/components/hew/HealthEducation.vue";
import DiseaseSurveillance from "@/components/hew/DiseaseSurveillance.vue";
import HEWReports from "@/components/hew/HEWReports.vue";

import PlansManagement from "@/components/cbhi-plans/PlansManagement.vue";
import ServicesManagement from "@/components/cbhi-plans-services/ServicesManagement.vue";

import RoleManagement from "@/components/RoleManagement.vue";
import PremiumHandoverManagement from "@/components/cbhi-collector-handover/PremiumHandoverManagement.vue";
import MemberCardView from "@/components/cbhi-member-management/MemberCardView.vue";
import CBHILandingPage from "@/components/landing/CBHILandingPage.vue";
import Cbhiaboutpage from "@/components/landing/Cbhiaboutpage.vue";
import Cbhibenefitspage from "@/components/landing/Cbhibenefitspage.vue";
import Cbhiservicespage from "@/components/landing/Cbhiservicespage.vue";
import Cbhienrollmentpage from "@/components/landing/Cbhienrollmentpage.vue";
import Cbhifacilitiespage from "@/components/landing/Cbhifacilitiespage.vue";
import cbhifaqspage from "@/components/landing/Cbhifaqspage.vue";
import Cbhicontactpage from "@/components/landing/Cbhicontactpage.vue";
import CBHIMemberLogin from "@/components/landing/CBHIMemberLogin.vue";
import MemberSetPassword from "@/components/landing/MemberSetPassword.vue";
import MemberMyProfile from "@/components/member-portal/MemberMyProfile.vue";
import MemberDashboard from "@/components/member-portal/MemberDashboard.vue";
import MemberCoverage from "@/components/member-portal/MemberCoverage.vue";
import BeneficiariesList from "@/components/member-portal/BeneficiariesList.vue";
import MyMembershipCard from "@/components/member-portal/MyMembershipCard.vue";
import PaymentHistory from "@/components/member-portal/PaymentHistory.vue";
import ClaimsList from "@/components/member-portal/ClaimsList.vue";





const routes =[

    {
        path:"/collector-handover-management",
        name:"collector-handover-management",
        component: PremiumHandoverManagement,
        meta:{public: false}
    },

    {
        path:"/role-management",
        name:"role-management",
        component: RoleManagement,
        meta:{public: false}
    },

    {
        path: '/services-management',
        name: 'services-management',
        component: ServicesManagement
    },

    {
        path: '/plans-management',
        name: 'plans-management',
        component: PlansManagement
    }, {
        path: '/cash-collection',
        name: 'cash-collection',
        component: CashCollectionDashboard
    },
    {
        path: '/user-profile',
        name: 'user-profile',
        component: UserProfile
    },

    {
        path: '/settlement-management',
        name: 'settlement-management',
        component: SettlementManagement
    },

    {
        path: '/claims-management',
        name: 'claims-management',
        component: ClaimsManagement
    },


    {
        path: '/premium-receive',
        name: 'ReceivePremium',
        component: ReceivePremium
    },

    {
        path: '/members-edit#:cbhi_number',
        name: 'members-edit',
        component: MembersEdit
    },

    {
        path: '/member-details#:cbhi_number',
        name: 'member-details',
        component: MemberDetails,
        meta:{public: true}
    },

    // ✅ NEW ROUTE - CBHI Card View/Print
    {
        path: '/member-card#:cbhi_number',
        name: 'member-card',
        component: MemberCardView,
        meta:{public: false}
    },

    {
        path: '/hospitals-edit#:id',
        name: 'hospitals-edit',
        component: HospitalsEdit,
        meta:{public: true}
    },

    {
        path:"/use-logs",
        name:"UseLogs",
        component: UseLogs,
        meta:{public: true}
    },

    {
        path:"/users-roles",
        name:"UsersRoles",
        component: UsersRoles,
        meta:{public: true}
    },
    {
        path:"/user-userlist",
        name:"UserList",
        component: UserList,
        meta:{public: true}
    },
    {
        path:"/users-deactivated",
        name:"UsersDeactivated",
        component: UsersDeactivated,
        meta:{public: true}
    },

    {
        path:"/user-registration",
        name:"UserRegistration",
        component: UserRegistration,
        meta:{public: true}
    },

    {
        path:"/employment-types",
        name:"EmploymentTypes",
        component: EmploymentTypes,
        meta:{public: true}
    },
    {
        path:"/affiliated-institutions",
        name:"AffiliatedInstitution",
        component: AffiliatedInstitution,
        meta:{public: true}
    },


    {
        path:"/org-designations",
        name:"Designations",
        component: Designations,
        meta:{public: true}
    },


    {
        path:"/org-departments",
        name:"Departments",
        component: Departments,
        meta:{public: true}
    },

    {
        path:"/system-management",
        name:"system-management",
        component: SystemManagement,
        meta:{public: true}
    },

    {
        path:"/login",
        name:"login",
        component: Login,
        meta:{public: true}
    },

    {
        path:"/",
        name:"CBHILandingPage",
        component: CBHILandingPage,
        meta:{public: true}
    },

    {
        path:"/reset-password",
        name:"ResetPasswordPage",
        component: ResetPasswordPage,
        meta:{public: true}
    },


    {
        path:"/dashboard",
        name:"dashboard",
        component: Dashboard,
        meta:{public: false}
    },


    {
        path:"/hospitals-add",
        name:"HospitalsAdd",
        component: HospitalsAdd,
        meta:{public: false}
    },
    {
        path:"/hospitals",
        name:"Hospitals",
        component: Hospitals,
        meta:{public: false}
    },
    {
        path:"/members-add",
        name:"members-add",
        component: MembersAdd,
        meta:{public: false}
    },

    {
        path:"/bulk-upload-members",
        name:"bulk-upload-members",
        component: MemberBulkUpload,
        meta:{public: false}
    },

    {
        path:"/members-all",
        name:"members-all",
        component: MembersAll,
        meta:{public: false}
    },

    {
        path:"/members-flagged",
        name:"MembersFlagged",
        component: MembersFlagged,
        meta:{public: false}
    },
    {
        path:"/premium-records",
        name:"PremiumRecords",
        component: PremiumRecords,
        meta:{public: false}
    },

    {
        path:"/premium-reconciliation",
        name:"premium-reconciliation",
        component: PremiumReconciliation,
        meta:{public: false}
    },

    {
        path:"/premium-collections-report",
        name:"PremiumCollectionsReports",
        component: PremiumCollectionsReports,
        meta:{public: false}
    },


    // ===== HEALTH EXTENSION WORKER ROUTES =====
    {
        path: '/hew-dashboard',
        name: 'hew-dashboard',
        component: HEWDashboard,
        meta: { public: false }
    },

    {
        path: '/household-management',
        name: 'household-management',
        component: HouseholdManagement,
        meta: { public: false }
    },

    {
        path: '/household-details',
        name: 'household-details-list',
        component: HouseholdDetails,
        meta: { public: false }
    },

    {
        path: '/household-details/:id',
        name: 'household-details',
        component: HouseholdDetails,
        meta: { public: false }
    },

    {
        path: '/member-profile',
        name: 'member-profile-list',
        component: MemberProfile,
        meta: { public: false }
    },

    {
        path: '/member-profile/:id',
        name: 'member-profile',
        component: MemberProfile,
        meta: { public: false }
    },

    {
        path: '/visit-details',
        name: 'visit-details-list',
        component: VisitDetails,
        meta: { public: false }
    },

    {
        path: '/visit-details/:id',
        name: 'visit-details',
        component: VisitDetails,
        meta: { public: false }
    },

    {
        path: '/health-education',
        name: 'health-education',
        component: HealthEducation,
        meta: { public: false }
    },

    {
        path: '/disease-surveillance',
        name: 'disease-surveillance',
        component: DiseaseSurveillance,
        meta: { public: false }
    },

    {
        path: '/hew-reports',
        name: 'hew-reports',
        component: HEWReports,
        meta: { public: false }
    },

    {
        path: '/about',
        name: 'about',
        component: Cbhiaboutpage,
        meta: { public: true }
    },

    {
        path: '/benefits',
        name: 'benefits',
        component: Cbhibenefitspage,
        meta: { public: true }
    },

    {
        path: '/services',
        name: 'services',
        component: Cbhiservicespage,
        meta: { public: true }
    },
    {
        path: '/enrollment',
        name: 'enrollment',
        component: Cbhienrollmentpage,
        meta: { public: true }
    },

    {
        path: '/facilities',
        name: 'facilities',
        component: Cbhifacilitiespage,
        meta: { public: true }
    },

    {
        path: '/faqs',
        name: 'faqs',
        component: cbhifaqspage,
        meta: { public: true }
    },
    {
        path: '/contact',
        name: 'contact',
        component: Cbhicontactpage,
        meta: { public: true }
    },
    {
        path: '/member-login',
        name: 'member-login',
        component: CBHIMemberLogin,
        meta: { public: true }
    },


    {
        path: '/set-password',
        name: 'set-password',
        component: MemberSetPassword,
        meta: { public: true }
    },
    {
        path: '/set-password',
        name: 'set-password',
        component: MemberSetPassword,
        meta: { public: true }
    },
    {
        path: '/my-profile',
        name: 'my-profile',
        component: MemberMyProfile,
        meta: { public: true }
    },
    {
        path: '/member-dashboard',
        name: 'member-dashboard',
        component: MemberDashboard,
        meta: { public: true }
    },

    {
        path: '/member-coverage',
        name: 'member-coverage',
        component: MemberCoverage,
        meta: { public: true }
    },
    {
        path: '/beneficiaries-list',
        name: 'beneficiaries-list',
        component: BeneficiariesList,
        meta: { public: true }
    },

    {
        path: '/my-member-card',
        name: 'my-member-card',
        component: MyMembershipCard,
        meta:{public: true}
    },
    {
        path: '/payment-history',
        name: 'payment-history',
        component: PaymentHistory,
        meta:{public: true}
    },


 {
        path: '/claims-list',
        name: 'claims-list',
        component: ClaimsList,
        meta:{public: true}
    },




]

const router = createRouter({
    history: createWebHashHistory(),
    routes
});


let userActivityTimer;

router.beforeEach((to, from, next) => {
    // Reset the user activity timer on each navigation
    clearTimeout(userActivityTimer);

    // Check if the target route requires authentication
    if (!to.meta.public && !to.hash.includes('/trade/')) {
        // Check if the user is logged in or not
        if (sessionStorage.getItem("isLoggedIn")) {
            // If yes, allow the navigation
            next();

            // Set up the user activity timer
            userActivityTimer = setTimeout(() => {
                // Log out the user after 5 minutes of inactivity
                sessionStorage.removeItem("isLoggedIn");
                next("/");
            }, 10 * 60 * 1000); // 10 minutes in milliseconds
        } else {
            // If no, redirect the user to the login page
            next("/");
        }
    } else {
        // If the target route does not require authentication or has parameters, allow the navigation
        next();
    }
});

// Optionally, you may want to handle user activity within the application
// to reset the timer. Here's an example assuming you have a user activity event.

// Example: Reset timer on user activity
function handleUserActivity() {
    clearTimeout(userActivityTimer);
    userActivityTimer = setTimeout(() => {
        // Log out the user after 24 hours of inactivity
        router.push("/");
    }, 24 * 60 * 60 * 1000); // 24 hours in milliseconds
}


// Attach an event listener for user activity (e.g., mousemove, keypress, etc.)
document.addEventListener("mousemove", handleUserActivity);
document.addEventListener("keypress", handleUserActivity);

// Remember to remove event listeners when they are no longer needed (e.g., when user logs out)
// document.removeEventListener("mousemove", handleUserActivity);
// document.removeEventListener("keypress", handleUserActivity);

export default router;